import { Component, OnInit, ViewChild } from "@angular/core";
import { AsignacionService } from "./asignacion.service";
import { ListColumn } from "src/app/models/list-columns.model";
import { CardTableComponent } from "src/app/components/cards/card-table/card-table.component";
import Swal from "sweetalert2";
import { MatDialog } from "@angular/material/dialog";
import { AsignarModal } from "./modal/modal.component";
import { LayoutsService } from "src/app/services/layouts.service";
import { UnidadesDTO } from "src/app/models/unidades.dto";
import { HistorialAsignarModal } from "./historial/historial.component";
import { Filter } from "src/app/shared/classes/filter";
import { Condition } from "src/app/models/custom-types";
import { FilterEvent } from "src/app/models/filter";
import { AlertasSwalService } from "src/app/services/alerts.service";

import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import * as dayjs from "dayjs";

dayjs.extend(utc);
dayjs.extend(timezone);

@Component({
  selector: "app-asignacion",
  templateUrl: "./asignacion.component.html",
  styles: [],
})
export class AsignacionComponent implements OnInit {
  public actions: any[] = [
    {
      desc: "Asignar",
      action: "asignar",
      visible: (row) => row.Estado == "Y" || row.Estado == "A",
    },
    {
      desc: "Desasignar",
      action: "desasignar",
      visible: (row) => row.Estado == "A",
    },
    {
      desc: "Historial",
      action: "historial",
      visible: (row) => true,
    },
  ];

  public columns: ListColumn[] = [
    {
      name: "# Control",
      property: "NoControl",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Supervisor",
      property: "Supervisor",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Chofer",
      property: "Chofer",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Empresa",
      property: "Empresa",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Estado",
      property: "Estado",
      visible: true,
      isModelProperty: false,
      transform: (val) => {
        return val == "Y" ? "✅" : val == "A" ? "🧑🏼‍✈️" : val == "T" ? "🛠️" : "🛣️";
      },
    },
    {
      name: "actions",
      property: "actions",
      visible: true,
      isModelProperty: false,
    },
  ];
  @ViewChild(CardTableComponent, { static: true })
  public tableComp: CardTableComponent;
  filtro: string = "";
  realdata: UnidadesDTO[];

  constructor(
    public service: AsignacionService,
    public dialog: MatDialog,
    public layoutServ: LayoutsService,
    public alerts: AlertasSwalService
  ) {
    this.layoutServ.changeHeader("Asignacion de unidades");
  }

  ngOnInit(): void {
    this.loadRecords();
    this.filter = new Filter<UnidadesDTO>(this.conditions, this.columns, true);
  }

  loadRecords() {
    this.service.get().subscribe(
      (resultData) => {
        this.realdata = resultData
          .filter((f) => f.Activo)
          .sort((a, b) => a.NoControl - b.NoControl);
        this.filter.setDataTable(this.realdata, this.tableComp);
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }

  //#region Filter

  public filter: Filter<UnidadesDTO>;
  public conditions: Condition<UnidadesDTO> = {
    NoControl: (o, f) => o.NoControl.toLocaleLowerCase().indexOf(f) > -1,
    Supervisor: (o, f) =>
      (o.Supervisor ?? "").toString().toLocaleLowerCase().indexOf(f) > -1,
    Chofer: (o, f) =>
      (o.Chofer ?? "").toString().toLocaleLowerCase().indexOf(f) > -1,
    Empresa: (o, f) =>
      (o.Empresa ?? "").toString().toLocaleLowerCase().indexOf(f) > -1,
  };

  filterdata(e: FilterEvent) {
    this.filter.filterdata(e, this.realdata, this.tableComp);
  }

  //#endregion Filter

  actionstable(e: { action: string; row: any }) {
    if (e.action == "asignar") {
      this.preopendialog(e.row.IdUnidad);
    } else if (e.action == "historial") {
      this.opendialoghistorial(e.row.IdUnidad);
    } else if (e.action == "desasignar") {
      this.desasignar(e.row.IdUnidad);
    }
  }

  preopendialog(id) {
    this.service.getCombosModal().subscribe((s) => {
      const listC = s.Choferes.map((m) => {
        return { Id: m.IdTrabajador, Desc: m.Nombre };
      });
      const listS = s.Supervisores.map((m) => {
        return { Id: m.IdTrabajador, Desc: m.Nombre };
      });
      this.opendialogasignar(id, listC, listS);
    });
  }
  async opendialogasignar(
    id,
    listC: { Id: any; Desc: any }[],
    listS: { Id: any; Desc: any }[]
  ) {
    const result = await this.dialog
      .open(AsignarModal, {
        panelClass: ["w-full", "lg:w-1/2"],
        data: { listS, listC, title: "Asignar" },
      })
      .afterClosed()
      .toPromise();

    if (result) {
      this.service
        .asignar({
          IdUnidad: id,
          IdChofer: result.IdChofer,
          IdSupervisor: result.IdSupervisor,
        })
        .subscribe(
          (event) => {
            if (event.status === "Good") {
              this.alerts.correcta("Correcto", "Asignacion guardada");
              this.loadRecords();
            } else {
              this.alerts.error("Error", "Ocurrio un error");
            }
          },
          (err) => {
            this.alerts.error("Error", "Ocurrio un error");
          }
        );
    }
  }

  async opendialoghistorial(id) {
    this.service.getHistorial(id).subscribe(
      (resultData) => {
        const list = resultData.map((m) => {

        const date = dayjs.utc(m.FechaCreado);

        // Convert to GMT -8 (Pacific Time)
        const gmt8Date = date.tz("America/Los_Angeles");
        const fechaTransform = m.FechaCreado ? gmt8Date : null;
        return {
          ...m,
          FechaCreadoStr: fechaTransform
            ? fechaTransform.format("DD/MM/YYYY hh:mm a")
            : "",
        };

        });

        this.dialog
          .open(HistorialAsignarModal, {
            panelClass: ["modal-for-table", "w-full", "lg:w-1/2"],
            data: {
              list: list,
            },
          })
          .afterClosed()
          .toPromise();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }
  async desasignar(id) {
    this.service
      .desasignar({
        IdUnidad: id,
      })
      .subscribe(
        (event) => {
          if (event.status === "Good") {
            this.alerts.correcta("Correcto", "Asignacion guardada");
            this.loadRecords();
          } else {
            this.alerts.error("Error", "Ocurrio un error");
          }
        },
        (err) => {
          this.alerts.error("Error", "Ocurrio un error");
        }
      );
  }
  templateClassRow(row) {
    return row.Estado == "T" ? "__r_t" : row.Estado == "R" ? "__r_r" : "";
  }
}
